module.exports = __webpack_public_path__ + "static/mapy-9b864703fe9b93ae73563b265de02cf3.png";